import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { AppLoader } from './States';

export const ProtectedRoute = ({ children }) => {
  const { user, ready } = useAuth();
  const loc = useLocation();
  if (!ready) return <AppLoader />;
  if (!user) return <Navigate to="/auth/login" state={{ from: loc }} replace />;
  // Autopay must be set up before entering the app
  if (user.requiresAutopay && loc.pathname !== '/choose-plan') return <Navigate to="/choose-plan" replace />;
  return children;
};

export const OnboardingRoute = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready) return <AppLoader />;
  if (!user) return <Navigate to="/auth/signup" replace />;
  if (user.requiresAutopay) return <Navigate to="/choose-plan" replace />;
  if (user.onboarded) return <Navigate to="/dashboard" replace />;
  return children;
};
